import * as Yup from 'yup'

export const ContractorPortalVerifyPhoneModalSchema = Yup.object().shape({
  code: Yup.string().required('Verification code is required'),
})
